import script from "./RequiredWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequiredWarning.vue?vue&type=script&setup=true&lang=ts"

import "./RequiredWarning.vue?vue&type=style&index=0&id=1f5b9c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5b9c8c"]])

export default __exports__